import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import ExportUtil from '../../../../common/ExportUtil';

const RadioGroup = Radio.Group;

class Export extends Component {
    state = {
        visible: false,
        language: undefined,
    }

    show = () => {
        this.setState({
            visible: true,
            language: undefined,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { language } = this.state;
        if (!language) {
            message.warning('请选择要导出的语言');
            return;
        }
        this.hide();
    }

    handleChange = (e) => {
        this.setState({ language: e.target.value });
    }

    render() {
        const { visible, language } = this.state;
        const radioStyle = { marginTop: 10, marginLeft: 6 };
        return (
            <Modal
                title="导出报价单"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ marginBottom: 10 }}>
                        报价单号：20190508003
                        <span className="ant-divider" />
                        Salesforce ID：CTTQ20200730
                        <span className="ant-divider" />
                        当前版本：V1
                    </div>
                    <div style={{ padding: 10, background: '#f1f1f1' }}>请选择报价单语言：</div>
                    <RadioGroup onChange={this.handleChange} value={language}>
                        <div style={radioStyle}><Radio value="zh">中文</Radio></div>
                        <div style={radioStyle}><Radio value="en">英文</Radio></div>
                        <div style={radioStyle}><Radio value="zh_en">中文+英文</Radio></div>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

export default Export;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/Components/Export.js